module.exports = __webpack_public_path__ + "assets/images/red-ff4cee354dabc989e2902c79aeb273bc.png";